import 'src/global.css';

import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';
import { Router } from 'src/routes/sections';
import { primary } from 'src/theme/core/palette';
import { Snackbar } from 'src/components/snackbar';
import { schemeConfig } from 'src/theme/scheme-config';
import { ThemeProvider } from 'src/theme/theme-provider';
import { ProgressBar } from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { HydrationGuard } from 'src/components/hydration-guard';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';
import { CustomLocalizationProvider } from 'src/components/localization-provider';
import { AuthProvider as JwtAuthProvider } from 'src/auth/context/jwt';

const AuthProvider = JwtAuthProvider;

if (typeof document !== 'undefined') {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', primary.main);
}

export default function App() {
  return (
    <>
      <InitColorSchemeScript
        defaultMode={schemeConfig.defaultMode}
        modeStorageKey={schemeConfig.modeStorageKey}
        colorSchemeSelector={schemeConfig.colorSchemeSelector}
      />
      <AuthProvider>
        <SettingsProvider settings={defaultSettings}>
          <ThemeProvider>
            <CustomLocalizationProvider>
              <MotionLazy>
                <HydrationGuard />
                <Snackbar />
                <ProgressBar />
                <SettingsDrawer />
                <Router />
              </MotionLazy>
            </CustomLocalizationProvider>
          </ThemeProvider>
        </SettingsProvider>
      </AuthProvider>
    </>
  );
}
